import { useStore } from "@/store/authStore";
import { useRoleStore } from "@/store/roleStore";
import axios from "axios";
import { useJwt } from "@vueuse/integrations/useJwt";
import { useApiStore } from "@/store/apiStore";

const loginUser = {
  isLogin: false,
  userName: "",
};

const payload = {
  decodeToken: "",
  userInfo: "",
};
export default function () {
  const store = useStore(); // Piniaのstoreを使用
  const roleStore = useRoleStore();
  const apiStore = useApiStore();
  const apiUrl = apiStore.getLoginPath;

  // ログイン処理を行う非同期関数
  const loginAccount = async (loginForm) => {
    try {
      // Spring Bootにログインリクエストを送る
      const response = await requestServerPost(apiUrl, loginForm);
      if (response.status != 200) {
        return response;
      }
      const accessToken = response.data.accessToken;
      const decodeToken = useJwt(accessToken);
      //const token = JSON.parse(JSON.stringify({ accessToken: accessToken }));
      // ログインが失敗した場合、エラーメッセージを返す
      if (!decodeToken) {
        return accessToken;
      }
      const loginName = await requestName(apiStore.getProfilePath, accessToken);
      roleStore.setRole(decodeToken.payload.value.permit);
      payload.decodeToken = decodeToken;
      payload.userInfo = loginName;
      loginUser.isLogin = true;
      loginUser.userName = loginName.data.name;
      //loginUser.userName = decodeToken.payload.value.sub;
      // ログインが成功した場合、トークン、ログイン情報、権限をvuexに格納し、'Success'を返す
      store.setIsLogin(true);
      store.setAuthToken(accessToken);
      store.setPayload(payload);
      return loginUser;
    } catch (error) {
      return error;
    }
  };

  // axiosのPOSTメソッドを使用してSpring Bootにリクエストを送る非同期関数
  const requestServerPost = async (url, formData) => {
    try {
      console.log(url);
      const response = await axios.post(url, formData);
      if (response.data.accessToken != null) {
        const token = response.data.accessToken;
        store.setAuthToken(token);
      }
      return response;
    } catch (error) {
      console.error(error);
      return error;
    }
  };

  const requestName = async (url, accessToken) => {
    try {
      console.log(url);
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return response;
    } catch (error) {
      console.error(error);
      return error;
    }
  };

  // モジュールの公開関数を返す
  return {
    loginAccount,
  };
}
